import MuiAccordion from './MuiAccordion';
import MuiAccordionDetails from './MuiAccordionDetails';
import MuiAccordionSummary from './MuiAccordionSummary';
import MuiAlert from './MuiAlert';
import MuiAutocomplete from './MuiAutocomplete';
import MuiButton from './MuiButton';
import MuiButtonBase from './MuiButtonBase';
import MuiButtonGroup from './MuiButtonGroup';
import MuiCard from './MuiCard';
import MuiCardContent from './MuiCardContent';
import MuiChip from './MuiChip';
import MuiDataGrid from './MuiDataGrid';
import MuiDialog from './MuiDialog';
import MuiPickersMonth from './MuiPickersMonth';
import MuiDialogTitle from './MuiDialogTitle';
import MuiDialogContent from './MuiDialogContent';
import MuiDivider from './MuiDivider';
import MuiFilledInput from './MuiFilledInput';
import MuiFormControl from './MuiFormControl';
import MuiFormLabel from './MuiFormLabel';
import MuiInput from './MuiInput';
import MuiInputBase from './MuiInputBase';
import MuiInputLabel from './MuiInputLabel';
import MuiLinearProgress from './MuiLinearProgress';
import MuiMenu from './MuiMenu';
import MuiMenuItem from './MuiMenuItem';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiPopover from './MuiPopover';
import MuiSelect from './MuiSelect';
import MuiSvgIcon from './MuiSvgIcon';
import MuiSwitch from './MuiSwitch';
import MuiSnackbar from './MuiSnackbar';
import MuiTab from './MuiTab';
import MuiTablePagination from './MuiTablePagination';
import MuiTabs from './MuiTabs';
import MuiTextField from './MuiTextField';
import MuiToggleButton from './MuiToggleButton';
import MuiToggleButtonGroup from './MuiToggleButtonGroup';
import MuiToolbar from './MuiToolbar';

const components = {
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary,
  MuiAlert,
  MuiAutocomplete,
  MuiButton,
  MuiButtonBase,
  MuiButtonGroup,
  MuiCard,
  MuiCardContent,
  MuiChip,
  MuiDataGrid,
  MuiDialog,
  MuiDialogContent,
  MuiDialogTitle,
  MuiDivider,
  MuiFilledInput,
  MuiFormControl,
  MuiFormLabel,
  MuiInput,
  MuiInputBase,
  MuiInputLabel,
  MuiLinearProgress,
  MuiMenu,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiPickersMonth,
  MuiPopover,
  MuiSelect,
  MuiSnackbar,
  MuiSvgIcon,
  MuiSwitch,
  MuiTab,
  MuiTablePagination,
  MuiTabs,
  MuiTextField,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiToolbar,
};

export default components;
